module.exports = __webpack_public_path__ + "img/upload-placeholder.5873c813.svg";